var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIPill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.22708,
    y: 10.1202,
    width: 9.74944,
    height: 3.74978,
    rx: 1.87489,
    transform: "rotate(-45 3.22708 10.1202)",
    stroke: "white",
    strokeWidth: 0.749957
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.93948 6.4079L8.79553 4.55185C9.52772 3.81966 10.7148 3.81966 11.447 4.55185C12.1792 5.28404 12.1792 6.47116 11.447 7.20335L9.59098 9.0594L6.93948 6.4079Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.749957
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIPill);
export default __webpack_public_path__ + "static/media/i_pill.03c4527f7869b1a240543634d72002ce.svg";
export { ForwardRef as ReactComponent };